import { makeStyles, createStyles } from '@material-ui/core/styles';
import { variables } from '@styles';

export const useToggleButtonStyles = makeStyles(() =>
  createStyles({
    root: {
      backgroundColor: variables.colorV2.button.switch.background.default,
      borderColor: variables.colorV2.button.switch.border.default,
      borderRadius: '2rem',
      color: variables.colorV2.button.switch.text.default,
      fontSize: '1.3rem',
      fontWeight: 400,
      height: '3.2rem',
      // minWidth: '17rem',
      lineHeight: '3rem',
      padding: '0 16px',
      textTransform: 'none',

      '& svg path': {
        fill: variables.colorV2.button.alternate.icon.default,
      },

      '&:hover': {
        backgroundColor: variables.colorV2.button.alternate.background.default,
        borderColor: variables.colorV2.button.alternate.border.hover,

        '& svg path': {
          fill: variables.colorV2.button.alternate.icon.hover,
        },
      },
    },
    selected: {
      backgroundColor: variables.colorV2.button.default.background.default,
      borderColor: variables.colorV2.button.default.border.default,
      color: variables.colorV2.button.switch.text.active,
      '& svg path': {
        fill: variables.colorV2.button.default.icon.default,
      },
      '&:hover': {
        backgroundColor: variables.colorV2.button.default.background.hover,
        '& svg path': {
          fill: variables.colorV2.button.default.icon.hover,
        },
      },
      '&.MuiToggleButton-root.Mui-selected': {
        backgroundColor: variables.colorV2.button.default.background.active,
        color: variables.colorV2.button.switch.text.active,
      },
    },
    disabled: {
      backgroundColor: variables.colorV2.button.disabled.background.default,
      borderColor: variables.colorV2.button.disabled.border.default,

      '&.MuiToggleButton-root.Mui-selected': {
        backgroundColor: variables.colorV2.button.disabled.background.active + ' !important',
      },
    },
  }),
);
